/**
 * @file Vue mixin for making the app fullscreen on the browser
 **/
import { enterFullscreen, exitFullscreen, observeFullscreen } from 'bits/fullscreen'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

const browser = namespace('browser')

@Component
export default class extends Vue {
  unobserveFullscreen: (() => void) | null = null
  @browser.Getter isFullscreen!: boolean
  @browser.Action enterFullscreen!: () => void
  @browser.Action exitFullscreen!: () => void

  @Watch('isFullscreen')
  updateFullscreen(): void {
    this.isFullscreen ? enterFullscreen() : exitFullscreen()
  }

  observeFullscreenHandler(enteringFullscreen: boolean): void {
    const exitingFullscreen = !enteringFullscreen
    if (!this.isFullscreen && enteringFullscreen) this.enterFullscreen()
    if (this.isFullscreen && exitingFullscreen) this.exitFullscreen()
  }

  mounted(): void {
    this.unobserveFullscreen = observeFullscreen(this.observeFullscreenHandler.bind(this))
  }

  beforeDestroy(): void {
    this.unobserveFullscreen && this.unobserveFullscreen()
  }
}
